import { Box, CSSObject } from '@mui/material'
import { mdParser } from './mdParser'


type MdViewProps = {
    mdContent: string,
    sx?: CSSObject,

}

export const MdView = ({ sx, mdContent }: MdViewProps) => {
    return <Box
        sx={{
            fontSize: '14px',
            ...(sx || {}),
        }}
        dangerouslySetInnerHTML={{
            __html: mdParser.render(mdContent ?? ''),
        }}
    />
}